<template>
  <el-menu :collapse-transition="false" class="menu-list" :unique-opened="true" background-color="#35395C" text-color="#9A9CAD" active-text-color="#FFFFFF" :default-active="currentMenu" @select="handleSelectMenu" @open="openSubMenu" :collapse="collapseFlag">
    <template v-for="(item, index) in menuList">
      <template v-if="item.menu">
        <el-submenu :key="index" :index="String(index)">
          <template slot="title">
            <!-- <i :class="item.icon"></i> -->
            <img class="e-image" :src="item.img" :title="item.title" />

            <!-- <el-image class="e-image" style="width: 50px; height: 50px vertical-align: top" :src="item.img" :title="item.title"></el-image> -->
            <span v-if="!collapseFlag" class="menu-title">{{item.title}}</span>
          </template>
          <div v-for="(item2, index2) in item.menu" :key="index2">
            <template v-if="item2.menu">
              <el-submenu :index="`${String(index)}-${String(index2)}`">
                <template slot="title">
                  <span class="menu-title">{{item2.title}}</span>
                </template>
                <el-menu-item v-for="(item3, index3) in item2.menu" :key="index3" :index="item3.path">
                  <span>{{ item3.title }}</span>
                </el-menu-item>
              </el-submenu>
            </template>
            <el-menu-item v-else :index="item2.path">
              <span>{{ item2.title }}</span>
            </el-menu-item>
          </div>
        </el-submenu>
      </template>
      <template v-else>
        <el-menu-item style="padding-left:16px" :index="item.path" :key="index">
          <!-- <i>{{ item.title.substring(0,1) }}</i> -->
          <!-- <el-image class="e-image" style="width: 30px; height: 30px vertical-align: top" :src="item.img" :title="item.title"></el-image> -->
          <img class="e-image" :src="item.img" :title="item.title" />
          <span v-if="!collapseFlag"> {{ item.title }}</span>

        </el-menu-item>
      </template>
    </template>
  </el-menu>
</template>

<script>
import { list } from '@/api/front.js';

export default {
  name: 'OperationMenu',
  props: {
    collapseFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuList: [],
      openIndex: '',
    };
  },

  created() {
    // 分发store的请求
    // this.$store.dispatch('getList')
    this.getList();
  },

  computed: {
    // 计算属性
    // apiMenuList() {
    //   let list = this.$store.getters.gameList
    //   var resList = []
    //   for(var item of list){
    //       let menu ={
    //         title:item.gameName,
    //         icon:'',
    //         iconActive:'',
    //         path:'/game/page/'+item.gameAlias
    //       }
    //       resList.push(menu)
    //     }
    //   return resList
    // },

    collapse() {
      // TODO
      return this.$store.state.menu.collapse;
    },

    currentMenu() {
      // TODO
      return this.$route.path;
    },
  },

  mounted() {},

  methods: {
    getList() {
      list().then((res) => {
        for (const item of res) {
          const menu = {
            title: item.gameName,
            icon: '',
            iconActive: '',
            img: item.img,
            path: `/game/page/${item.gameAlias}`,
          };
          this.menuList.push(menu);
        }
        const { path } = this.$route;
        if (path === '/game/page/game') {
          // 默认跳转到第一个项目
          this.$router.push(this.menuList[0].path);
        }
      });
    },

    menuFilter(destMenu, originMenu, userPermissions) {
      if (!originMenu || originMenu.length === 0) {
        return;
      }

      originMenu.forEach((menuItem) => {
        if (
          !menuItem.permission
          || userPermissions.includes(menuItem.permission)
        ) {
          const currentMenu = menuItem;

          if (menuItem.menu) {
            const subMenu = [];
            this.menuFilter(subMenu, menuItem.menu, userPermissions);
            currentMenu.menu = subMenu;
          }

          if (currentMenu.path || currentMenu.menu.length) {
            destMenu.push(currentMenu);
          }
        }
      });
    },

    handleSelectMenu(menu) {
      const { path, fullPath } = this.$route;
      const shouldReload = path === menu && fullPath !== menu;

      this.$router.push(menu);
      this.$emit('noCollapse');

      if (shouldReload) {
        this.$emit('routerChange', 1);
      }
    },

    openSubMenu(index) {
      this.openIndex = index;
    },

    // XXX
    getIcon(menuItem, index) {
      if (this.openIndex === '') {
        return menuItem.menu.some(item => item.path === this.currentMenu)
          ? menuItem.iconActive
          : menuItem.icon;
      }

      return Number(this.openIndex) === Number(index)
        ? menuItem.iconActive
        : menuItem.icon;
    },
  },
};
</script>

<style lang="less" scoped>
.menu-list {
  overflow: auto;
}
.menu-icon {
  margin-right: 10px;
}
.e-image img {
  display: inline-block;
  width: 100%;
}
.el-image .el-image__inner--center {
  display: inline-block;
  width: 100%;
}
</style>
<style>
.e-image {
  display: inline-block;
  width: 30px;
}
.el-image .el-image__inner--center {
  display: inline-block;
  width: 100%;
}
</style>
